export const IGetImageCacheStrategyUseCaseType = Symbol('IGetImageCacheStrategyUseCase');
